import { useCallback, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { EDGE_FUNCTION_URL, fetchSession } from '@/lib/traccar-api';

export const useTraccarSession = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const location = useLocation();

  const { data: user, isLoading, isError } = useQuery({
    queryKey: ['session'],
    queryFn: fetchSession,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    if (isError && location.pathname !== '/login') {
      navigate('/login');
    }
  }, [isError, location.pathname, navigate]);

  const login = useCallback(async () => {
    await queryClient.refetchQueries({ queryKey: ['session'] });
  }, [queryClient]);

  const logout = useCallback(async () => {
    try {
      await fetch(`${EDGE_FUNCTION_URL}/api/session`, { method: 'DELETE' });
    } catch (error) {
      console.error('Failed to logout:', error);
    }
    queryClient.setQueryData(['session'], null);
    queryClient.clear();
    navigate('/login');
  }, [queryClient, navigate]);

  return { isAuthenticated: true, isLoading, user, login, logout };
};
